import { createTheme } from '@mui/material';

export const themeCustomValues = {
	borderRadius: '10px',
};

const colors = {
	light: {
		main: '#302F31',
	},
	dark: {
		main: '#ffffff',
	},
};

const theme = createTheme({
	typography: {
		fontFamily: 'Rubik, Raleway, Arial',
		button: {
			textTransform: 'none',
		},
		allVariants: {
			color: colors.light.main,
		},
		body1: {
			color: colors.light.main,
		},
		body2: {
			color: colors.light.main,
		},
		h6: {
			color: '#79777C',
		},
	},
	palette: {
		primary: {
			light: '#79777C',
			main: colors.light.main,
			contrastText: '#ffffff',
			// dark: will be calculated from palette.primary.main,
			// contrastText: will be calculated to contrast with palette.primary.main
		},
		secondary: {
			main: '#ff7062',
			contrastText: '#ffffff',
			// dark: will be calculated from palette.secondary.main,
		},
		// Provide every color token (light, main, dark, and contrastText) when using
		// custom colors for props in Material UI's components.
		// Then you will be able to use it like this: `<Button color="custom">`
		// (For TypeScript, you need to add module augmentation for the `custom` value)
		custom: {
			main: '#79777C',
			contrastText: colors.light.main,
		},
		// Used by `getContrastText()` to maximize the contrast between
		// the background and the text.
		contrastThreshold: 3,
		// Used by the functions below to shift a color's luminance by approximately
		// two indexes within its tonal palette.
		// E.g., shift from Red 500 to Red 300 or Red 700.
		tonalOffset: 0.2,
		borderRadius: {
			paper: '4px',
		},
	},
	shape: {
		borderRadius: '10px',
	},
	components: {
		MuiListItem: {
			styleOverrides: {
				root: {
					borderRadius: '10px',
					color: colors.light.main,
				},
			},
		},
		// Name of the component

		MuiListItemButton: {
			styleOverrides: {
				root: {
					// Styles applied to the root element

					borderRadius: '10px',
				},
			},
		},
		// MuiListItem: {
		// 	styleOverrides: {
		// 		root: {
		// 			// Styles applied to the root element
		// 			backgroundColor: '#fff',
		// 			borderRadius: '4px',
		// 			color: colors.light.main,
		// 		},
		// 	},
		// },

		MuiAvatar: {
			styleOverrides: {
				root: {
					// Styles applied to the root element
					background: '#ff7062',
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				containedPrimary: {
					// Styles applied to the root element
					fontWeight: 600,
				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				root: {
					color: colors.light.main,
				},
			},
		},
	},
});

const darkTheme = createTheme({
	typography: {
		fontFamily: 'Rubik, Raleway, Arial',
		button: {
			textTransform: 'none',
		},
		allVariants: {
			color: '#ffffff', // Change the text color to white
		},
		body1: {
			color: '#ffffff', // Change the text color to white
		},
		body2: {
			color: '#ffffff', // Change the text color to white
		},
	},
	palette: {
		primary: {
			main: '#ffffff',
			contrastText: '#1e1e1e',
		},
		secondary: {
			main: '#ff7062',
			contrastText: '#ffffff',
		},
		background: {
			paper: '#1e1e1e', // your color
		},
		borderRadius: {
			paper: '4px',
			button: '4px',
		},
		custom: {
			main: '#ffffff',
			contrastText: 'rgba(0, 0, 0, 0.87)',
		},
		type: 'dark', // Set the theme type to 'dark'
		contrastThreshold: 3,
		tonalOffset: 0.2,
	},
	shape: {
		borderRadius: '10px',
	},
	components: {
		MuiChip: {
			styleOverrides: {
				root: {
					// Styles applied to the root element
					color: '#fff',
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					// Styles applied to the root element
					borderColor: 'rgba(255, 255, 255, 0.1)',
				},
			},
		},
		MuiAvatar: {
			styleOverrides: {
				root: {
					// Styles applied to the root element
					background: '#ff7062',
				},
			},
		},
		MuiLinearProgress: {
			styleOverrides: {
				barColorPrimary: {
					backgroundColor: '#ff7062',
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				containedPrimary: {
					// Styles applied to the root element
					backgroundColor: '#ff7062',
					color: '#fff',
					fontWeight: 600,
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					color: '#fff',
					borderColor: '#fff',
				},
				notchedOutline: {
					borderColor: 'rgba(255,255,255,0.4)',
				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				root: {
					color: colors.dark.main,
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiInputBase-root.Mui-disabled>input': {
						color: '#fff', // Override text color
						'-webkit-text-fill-color': 'inherit',
					},
				},
			},
		},
		// Alternatively, target MuiInputBase globally
		MuiInputBase: {
			styleOverrides: {
				root: {
					'&.Mui-disabled': {
						color: '#fff',
					},
				},
			},
		},
		MuiListItem: {
			styleOverrides: {
				root: {
					borderRadius: '10px',
				},
			},
		},
		// Name of the component

		MuiListItemButton: {
			styleOverrides: {
				root: {
					// Styles applied to the root element

					borderRadius: '10px',
				},
			},
		},
	},
});

export default theme;
export { darkTheme };
